import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import type { IPublicClientApplication } from '@azure/msal-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import type { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { LogLevel, BrowserCacheLocation } from '@azure/msal-browser';
import type { Configuration } from '@azure/msal-browser';
import { registerLicense } from '@syncfusion/ej2-base';
import type { Params } from '@angular/router';

if (environment.production) {
  enableProdMode();
}

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

function bootstrapApp() {
  var req = new XMLHttpRequest();

  req.addEventListener('error', (res: any) => {
    console.log('Error: ', res);
  });
  
  req.addEventListener('load', async (res: any) => {
    const appConfig = JSON.parse(res.currentTarget.response);

    environment.defaultCountryId = appConfig.defaultCountryId;
    environment.esignatureBaseURL = appConfig.esignatureBaseURL;
    environment.englishLogo = appConfig.ClientLogo;
    environment.frenchLogo = appConfig.ClientLogoFrench;
    environment.consentScopes = appConfig.consentScopes;
    environment.termsAndConditionURL = appConfig.TermsAndConditionURL;
    environment.ldpaReturnURL = appConfig.ldpaReturnURL;
    environment.baseUrl = appConfig.apiBaseUrl;
    environment.tdThreeDSEnabled = appConfig.tdThreeDSEnabled;
    environment.userId =  appConfig.userId;
    environment.postLogoutRedirectUri = appConfig.postLogoutRedirectUri;
    environment.authority = appConfig.authority;
    environment.clientID = appConfig.clientID;
    environment.redirectUri = appConfig.redirectUri;
    environment.authority = appConfig.authority;
    environment.protectedResourceMap = appConfig.protectedResourceMap;
    environment.syncfusionKey = appConfig.syncfusionKey;
    environment.angularAppinsigthsKey = appConfig.angularAppinsigthsKey;
    environment.enableAppInsightTracking = appConfig.enableAppInsightTracking;
    environment.showReservation = appConfig.showReservation;
    environment.hCaptchaSiteKey=appConfig.hCaptchaSiteKey;
    await registerLicense(environment.syncfusionKey);
    
    import('./app/app.module').then(({ AppModule }) => {
      platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch(err => console.error(err));
    }).catch(err => {
      console.error('Failed to load AppModule dynamically:', err);
    });
  });

  req.open('GET', '/assets/config/config.json');
  req.send(null);
}

// When B2C redirects back with the auth code (popup or redirect flow), the URL hash/query
// contains a `state` parameter. broadcastResponseToMainFrame() handles this without
// bootstrapping the full Angular app: for popup flow it sends the BroadcastChannel message
// back to the parent window and closes the popup; for redirect flow it caches the response
// and navigates to the origin URL.
const urlHash = window.location.hash;
const urlQuery = window.location.search;
const hasAuthResponse =
  (urlHash.length > 1 && new URLSearchParams(urlHash.substring(1)).has('state')) ||
  (urlQuery.length > 1 && new URLSearchParams(urlQuery.substring(1)).has('state'));

if (hasAuthResponse) {
  broadcastResponseToMainFrame().catch(() => bootstrapApp());
} else {
  bootstrapApp();
}